{
    "name": "vroom",
    "version": "0.1.1",
    "scripts": {
        "ng": "ng",
        "start": "ng serve -o",
        "build": "ng build",
        "watch": "ng build --watch --configuration development",
        "build-dev": "ng build --configuration=development",
        "build-prod": "ng build --configuration=production",
        "copy-dev": "node transfer.js dev",
        "copy-prod": "node transfer.js prod"
    },
    "prettier": {
        "printWidth": 100,
        "singleQuote": true,
        "overrides": [
            {
                "files": "*.html",
                "options": {
                    "parser": "angular"
                }
            }
        ]
    },
    "private": true,
    "packageManager": "npm@10.8.2",
    "dependencies": {
        "@angular/common": "^21.1.0",
        "@angular/compiler": "^21.1.0",
        "@angular/core": "^21.1.0",
        "@angular/forms": "^21.1.0",
        "@angular/platform-browser": "^21.1.0",
        "@angular/router": "^21.1.0",
        "@fortawesome/fontawesome-free": "^7.2.0",
        "bootstrap": "^5.3.8",
        "ngx-bootstrap": "^21.0.1",
        "rxjs": "~7.8.0",
        "tslib": "^2.3.0",
        "moment": "^2.30.1"
    },
    "devDependencies": {
        "@angular/build": "^21.1.4",
        "@angular/cli": "^21.1.4",
        "@angular/compiler-cli": "^21.1.0",
        "@types/node": "^25.2.3",
        "jsdom": "^27.1.0",
        "typescript": "~5.9.2",
        "vitest": "^4.0.8",
        "node-ssh": "^13.2.1",
        "zip-a-folder": "^3.1.9"
    }
}
